import React from "react";
import "./styles/index.scss";
import HomeLogo from "../../common/icons/logos/homeLogo";
import HomeSmallLogo from "../../common/icons/logos/homeSmallLogo";
import HomeTextLogo from "../../common/icons/logos/homeTextLogo";
import { Route, Switch } from "react-router-dom";

import RegisterForm from "../register";
import RecoverForm from "../recover";
import ActivateForm from "../activate";
import ActivationLinkForm from "../activationLink";
import RecoverSuccessForm from "../recoverSuccess";
import LoginPage from "../login/LoginPage";

const GuestHome = () => {
  return (
    <React.Fragment>
      <div className="dealkit-logo-container">
        <div className="dealkit-logo">
          <HomeLogo />
          <div className="label-logo-container">
            <HomeTextLogo />
            <div className="label-logo-description">
              We make venture deals fast, clear and simple from term sheet to
              wire transfer.
            </div>
          </div>
          <HomeSmallLogo />
        </div>
        <div className="dealkit-form">
          <Switch>
            <Route exact path={`/register`} component={RegisterForm} />
            <Route exact path={`/recover`} component={RecoverForm} />
            <Route exact path={`/activate`} component={ActivateForm} />
            <Route
              exact
              path={`/send-activation-link/:email?`}
              component={ActivationLinkForm}
            />
            <Route
              exact
              path={`/recover-success`}
              component={RecoverSuccessForm}
            />
            <Route path={`/`} component={LoginPage} />
          </Switch>
        </div>
      </div>
    </React.Fragment>
  );
};

export default GuestHome;
